// extracted by mini-css-extract-plugin
module.exports = {"ingredientCards":"IngredientCards_ingredientCards__c6Lnn","title":"IngredientCards_title__BuAla","gridList":"IngredientCards_gridList__eXqYH"};